

























import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/components/common/elements/Typography.vue';
import List from '@/components/common/elements/List.vue';
import InformationModel from '@/models/informationModel';
import hexabaseState from '@/store/hexabase';

@Component({
  components: { Typography, List }
})

/* eslint-disable @typescript-eslint/camelcase */
export default class InformationPanel extends Vue {
  private records: Array<{ [k: string]: string }> = [];
  // マスタデータ格納プロパティ
  private displayData: { [k: string]: any }[] = [];
  // アプリケーションID
  private appId = hexabaseState.applicationId;
  // データストアID
  private mainDsId = hexabaseState.datastoreIds['お知らせ情報マスタ'];
  // お知らせ情報マスタのモデルをセット
  private informationModel = new InformationModel();

  mounted() {
    this.fetchInformationData();
  }

  /**
   * お知らせ情報の取得
   */
  async fetchInformationData() {
    try {
      this.displayData = await this.informationModel.getDisplayData(this.appId, this.mainDsId);
      this.displayData.forEach(item => {
        this.records.push({
          title: item['information_title'],
          text: item['information_contents']
        });
      });
    } catch (e) {
      if (e instanceof Error) {
        console.log(e.message);
      } else if (typeof e === 'string') {
        console.log(e);
      }
    }
  }
}
